var _ellipse, _path, _line;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0716,
    cy: 13.5414,
    rx: 13.0716,
    ry: 13.5414,
    fill: "#F4F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9094 13.6198C18.4971 10.8643 15.7013 9 12.5 9C9.29869 9 6.50207 10.8656 5.09061 13.6201C5.03104 13.7379 5 13.8681 5 14.0001C5 14.1322 5.03104 14.2624 5.09061 14.3802C6.50285 17.1357 9.29869 19 12.5 19C15.7013 19 18.4979 17.1344 19.9094 14.38C19.969 14.2621 20 14.1319 20 13.9999C20 13.8678 19.969 13.7376 19.9094 13.6198V13.6198ZM12.5 17.75C11.7583 17.75 11.0333 17.5301 10.4166 17.118C9.79992 16.706 9.31927 16.1203 9.03545 15.4351C8.75162 14.7499 8.67735 13.9959 8.82205 13.2684C8.96674 12.541 9.3239 11.8728 9.84834 11.3484C10.3728 10.8239 11.041 10.4668 11.7684 10.3221C12.4958 10.1774 13.2498 10.2516 13.9351 10.5355C14.6203 10.8193 15.206 11.2999 15.618 11.9166C16.0301 12.5333 16.25 13.2583 16.25 14C16.2502 14.4925 16.1534 14.9803 15.965 15.4354C15.7767 15.8904 15.5005 16.3039 15.1522 16.6522C14.8039 17.0005 14.3904 17.2767 13.9353 17.4651C13.4803 17.6534 12.9925 17.7503 12.5 17.75V17.75ZM12.5 11.5C12.2769 11.5031 12.0552 11.5363 11.8409 11.5987C12.0175 11.8387 12.1023 12.1341 12.0798 12.4312C12.0573 12.7284 11.9291 13.0076 11.7184 13.2184C11.5076 13.4291 11.2284 13.5573 10.9312 13.5798C10.6341 13.6023 10.3387 13.5175 10.0987 13.3409C9.96202 13.8444 9.98669 14.3782 10.1692 14.8669C10.3518 15.3557 10.683 15.775 11.1163 16.0656C11.5496 16.3563 12.0631 16.5038 12.5846 16.4873C13.1061 16.4708 13.6093 16.2912 14.0234 15.9738C14.4375 15.6564 14.7416 15.217 14.8929 14.7177C15.0443 14.2184 15.0352 13.6842 14.867 13.1903C14.6988 12.6964 14.38 12.2676 13.9554 11.9644C13.5308 11.6612 13.0218 11.4988 12.5 11.5V11.5Z",
    fill: "#757575"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.57417,
    y1: 20.738,
    x2: 16.5742,
    y2: 7.73795,
    stroke: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.af9c7781c86567d74972ae1020eb6da2.svg";
export { ForwardRef as ReactComponent };